import { ConnectedDevicesMap } from "fleet/controller/device/connected-devices-map";
import PropTypes from "prop-types";
import React from "react";
import { Box } from "view/layout/box";

function DevicesLocationMap(props) {
  const { devices } = props;

  return (
    <Box title="Device Location">
      <ConnectedDevicesMap devices={devices} minZoom={7} maxZoom={13} />
    </Box>
  );
}

DevicesLocationMap.propTypes = {
  devices: PropTypes.array.isRequired,
};

export { DevicesLocationMap };
